module.exports = __webpack_public_path__ + "static/media/error.9eca5f70.png";